<template>
  <v-footer color="white" height="auto">
    <v-row
      class="d-flex py-2"
      align="center"
      justify="space-around"
      no-gutters
    >
      <v-col
        cols="12"
        sm="4"
        class="order-1 order-sm-3 text-right"
        :class="{'text-center': xsOnly }"
      >
        <v-btn depressed plain small text target="_blank" to="/privacy">
          Privacy Policy
        </v-btn>
        <v-btn depressed plain small text target="_blank" :to="{name: 'terms'}">
          Terms &amp; Conditions
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="order-3 order-sm-1"
      >
        <p class="copyright" :class="{'text-center': xsOnly }">
          All content &copy; {{ new Date().getFullYear() }} by CHEF NATURELLE.
          <br/>Photography by Chio Fernandez and Nat Aubry.
        </p>
      </v-col>
      <v-col
        cols="12"
        sm="4"
        class="order-2 order-sm-2"
      >
        <v-row justify="center" class="text-center">
          <v-col xs12 sm5>
            <v-btn
              class="social mx-2"
              small
              icon
              href="https://www.instagram.com/chef_naturelle/"
              target="_blank"
            >
              <v-icon>fab fa-instagram</v-icon>
            </v-btn>
            <v-btn
              class="social mx-2"
              small
              icon
              href="https://www.facebook.com/chefnaturelle/"
              target="_blank"
            >
              <v-icon>fab fa-facebook</v-icon>
            </v-btn>
            <v-btn
              class="social mx-2"
              small
              icon
              href="https://uk.linkedin.com/in/stéphanie-cruchandeau-3b035a43"
              target="_blank"
            >
              <v-icon>fab fa-linkedin</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import {
  VBtn,
  VCol,
  VFooter,
  VIcon,
  VRow,
} from 'vuetify/lib'
export default {
  components: {
    VBtn,
    VCol,
    VFooter,
    VIcon,
    VRow,
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly
    }
  }
}
</script>

<style lang="scss">
footer {
  font-weight: normal;
}

.copyright {
  color: rgba(0, 0, 0, 0.54);
  font-size: 13px !important;
  margin: 0 !important;
}

.social {
  margin: 4px 0;
}
</style>
